import {ACTIVE_CHART, ADD_FLOORPLAN} from '../utils/constants';
import {initialState} from '../reducers'
//
console.log('activeChartReducer');
const activeChartReducer = (prevState, action) => {
  switch (action.type) {
    case ACTIVE_CHART:
      let newState = Object.assign({}, prevState)
      if (action.activeChart) {
        switch (action.activeChart) {
          case 'gantt':
            newState['gantt'].show = true;
            newState['idxCol'].show = true;
            break;
          case 'floorplan':
            newState['floorplan'].show = true;
            break;
          default:
          newState[action.activeChart].show = true;
        }
      }
      else if (action.inactiveChart) {
        switch (action.inactiveChart) {
          case 'gantt':
            newState['gantt'].show = false;
            newState['idxCol'].show = false;
            break;
          case 'home':
            newState['home'] = true;
            break;
          case 'floorplan':
            newState['floorplan'].show = false;
            break;
          default:
          newState[action.inactiveChart].show = false;
        }
      }
      return newState


    case ADD_FLOORPLAN:
      return action.newActiveChart
    default:
    if (prevState) {
      return prevState}
    else {return initialState.activeChart}

  }
}

export default activeChartReducer
///



// WEBPACK FOOTER //
// ./src/reducers/reducer-activeChart.js